import { degrees, PDFDocument } from 'pdf-lib';

/**
 * Rotates every page of a PDF by `delta` degrees (Kendo's PDFViewer has no
 * rotate tool). Accepts raw base64 or a `data:` URL and returns the same shape.
 */
export async function rotatePdfBase64(input: string, delta: 90 | -90): Promise<string> {
  const commaIdx = input.startsWith('data:') ? input.indexOf(',') : -1;
  const prefix = commaIdx >= 0 ? input.substring(0, commaIdx + 1) : '';
  const base64 = commaIdx >= 0 ? input.substring(commaIdx + 1) : input;

  const pdf = await PDFDocument.load(base64ToBytes(base64), { ignoreEncryption: true });
  for (const page of pdf.getPages()) {
    const angle = (page.getRotation().angle + delta + 360) % 360;
    page.setRotation(degrees(angle));
  }
  return prefix + bytesToBase64(await pdf.save());
}

function base64ToBytes(base64: string): Uint8Array {
  const bin = atob(base64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return bytes;
}

function bytesToBase64(bytes: Uint8Array): string {
  // Chunked so large PDFs don't overflow the call stack
  let bin = '';
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    bin += String.fromCharCode(...bytes.subarray(i, i + chunk));
  }
  return btoa(bin);
}
